export default __webpack_public_path__ + "static/media/juego1_ganar.d93daf35.png";